import removeFolderInListViewStore from '../actions/store-factory/removeFolderInListViewStore';
import { actionNames, DeleteFolderAction } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';

export default function deleteFolderInListViewStitch() {
    subscribe<DeleteFolderAction>(actionNames.DeleteFolderAction, (folderIds: string[]) => {
        // Delete each folder from the list view store
        // There could be multiple foldersIds if user is deleting a folder that has subfolders
        folderIds.forEach(folderId => {
            removeFolderInListViewStore(folderId);
        });
    });
}
